import { render, staticRenderFns } from "./fancyTable.vue?vue&type=template&id=11597424&"
import script from "./fancyTable.vue?vue&type=script&lang=js&"
export * from "./fancyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/nisems/front/nisbos-front-admin/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11597424')) {
      api.createRecord('11597424', component.options)
    } else {
      api.reload('11597424', component.options)
    }
    module.hot.accept("./fancyTable.vue?vue&type=template&id=11597424&", function () {
      api.rerender('11597424', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ls-form/components/saas/fancyTable.vue"
export default component.exports